module.exports = __webpack_public_path__ + "media/images/btn_manual_mares-e7938c12328db81237b3ba262cbda7c8.gif";